import { Button, Card, Center, Stack, Text, Title } from '@mantine/core';
import { useLoginPopup } from '@lib/auth/auth.hooks';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { IconLock } from '@tabler/icons-react';

export function NotLoggedIn() {
    // Get the redirect query param; default to "/" if missing.
    const search = useSearch({strict: false});
    const redirect = (search as { redirect?: string })?.redirect || "/";
    const navigate = useNavigate();

    // Modify your useLoginPopup hook to accept a callback if needed, otherwise it's fine
    const loginPopup = useLoginPopup();

    const handleLogin = async () => {
        console.log('Login button clicked with redirect to:', redirect);
        const success = await loginPopup(); // Assuming this returns true on success
        console.log('Login popup result:', success);

        if (success) {
            // Navigate immediately after successful login
            console.log('Login successful, navigating to:', redirect);
            // Small timeout might still be useful for MSAL state updates
            setTimeout(() => {
                navigate({to: redirect as any, replace: true}); // Use replace to avoid back button to login page
            }, 150);
        }
    };

    return (
            <Center
                    style={{
                        minHeight: '100vh',
                        padding: '2rem',
                        background: 'linear-gradient(135deg, var(--mantine-color-gray-0) 0%, var(--mantine-color-gray-1) 100%)',
                    }}
            >
                <Card
                        shadow="lg"
                        padding="xl"
                        radius="lg"

                        style={{
                            backdropFilter: 'blur(10px)',
                            backgroundColor: 'var(--mantine-color-body)',
                            borderColor: 'var(--mantine-color-gray-3)',
                            maxWidth: '450px',
                            width: '100%',
                            textAlign: 'center',
                        }}
                >
                    <Stack gap="lg" align="center">
                        <IconLock size={48} stroke={1.5} color="var(--mantine-color-blue-5)"/>
                        <Title
                                order={2}
                                style={{
                                    color: 'var(--mantine-color-text)',
                                    fontWeight: 700,
                                }}>
                            Access Restricted
                        </Title>

                        <Text c="dimmed" size="sm" style={{maxWidth: '90%'}}>
                            You need to be logged in to view this page.
                            {redirect !== "/" && (
                                    <>
                                        {' '}Access to{' '}
                                        <Text
                                                component="span"
                                                fw={500}
                                                inherit
                                                c="blue.6"
                                        >
                                            '{redirect.startsWith('/') ? redirect.substring(1) : redirect}'
                                        </Text>
                                        {' '}requires authentication.
                                    </>
                            )}
                        </Text>

                        <Button
                                variant="gradient"
                                gradient={{from: 'blue', to: 'cyan', deg: 90}}
                                size="md"
                                onClick={handleLogin}
                                fullWidth
                                mt="md"
                                leftSection={<IconLock size={18}/>}
                                style={{
                                    color: 'white',
                                }}
                        >
                            Sign In To Continue
                        </Button>
                    </Stack>
                </Card>
            </Center>
    );
}
